// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/pages/Contador/ContadorLayout.tsx
//  Moldura do Portal do Contador: sem a sessão do portal, manda para a entrada.
//  Não usa ProtectedRoute nem o menu do ERP (o contador não tem empresa nem perfis).
// ════════════════════════════════════════════════════════════════════════════

import { Link, Navigate, Outlet, useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { sessaoContador } from '@/features/contador/contadorClient';
import logo from '@/assets/logo.jpg';

export default function ContadorLayout() {
  const navigate = useNavigate();
  const usuario = sessaoContador.usuario();
  if (!sessaoContador.token() || !usuario) return <Navigate to="/contador/entrar" replace />;

  const sair = () => {
    sessaoContador.sair();
    navigate('/contador/entrar', { replace: true });
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-card">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-14 flex items-center gap-3">
          <Link to="/contador" className="flex items-center gap-3 min-w-0">
            <img src={logo} alt="Udisys" className="h-8 w-auto object-contain" />
            <span className="font-semibold hidden sm:inline">Portal do Contador</span>
          </Link>
          <div className="ml-auto flex items-center gap-3 min-w-0">
            <div className="text-right min-w-0">
              <p className="text-sm font-medium truncate">{usuario.escritorio.razaoSocial}</p>
              <p className="text-xs text-muted-foreground truncate">{usuario.nome}</p>
            </div>
            <Button variant="ghost" size="icon" onClick={sair} title="Sair">
              <LogOut className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto p-4 sm:p-6">
        <Outlet />
      </main>
    </div>
  );
}
